export default __webpack_public_path__ + "images/PG.2d09733.png";